const defaultHeaders = {
  "Content-Type": "application/json",
  "X-From-Channel": "DESKTOP_WEB",
};

export default defaultHeaders;
